module.exports = __webpack_public_path__ + "static/media/poppy.02f1ea55.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/poppy.png
// module id = 219
// module chunks = 0